import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';

import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { CiteService } from '../service/CiteService';
import { BatimentService } from '../service/BatimentService';
import { NiveauService } from '../service/NiveauService';
import { CouloirService } from '../service/CouloirService';
import { ChambreService } from '../service/ChambreService';
import { LitService } from '../service/LitService';
import { VilleService } from '../service/VilleService';
import { AffectationService } from '../service/AffectationService';
import { UtilisateurService } from '../service/UtilisateurService';
import { SessionService } from '../service/SessionService';

export default class AffectationLit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ine: '',
      student: null,
      user: null,
      searchMessage: '',
      villes : [],
      selectedVille: null,
      cites: [],
      selectedCite: null,
      session: null,
      batiments: [],
      selectedBatiment: null,
      niveaux: [],
      selectedNiveau: null,
      couloirs: [],
      selectedCouloir: null,
      chambres: [],
      selectedChambre: null,
      lits: [],
      selectedLit: null,
      occupants: [],  
      litsLibres: [],
      assignedModalVisible: false,
      assignedList: [],
      loading: false
    };

    this.onVilleChange = this.onVilleChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.searchStudent = this.searchStudent.bind(this);
    this.onCiteChange = this.onCiteChange.bind(this);
    this.onBatimentChange = this.onBatimentChange.bind(this);
    this.onNiveauChange = this.onNiveauChange.bind(this);
    this.onCouloirChange = this.onCouloirChange.bind(this);
    this.onChambreChange = this.onChambreChange.bind(this);
    this.assignToBed = this.assignToBed.bind(this);
    this.openAssignedModal = this.openAssignedModal.bind(this);
    this.exportAssignedExcel = this.exportAssignedExcel.bind(this);
    this.exportAssignedPdf = this.exportAssignedPdf.bind(this);

    this.villeService = new VilleService()
    this.citeService = new CiteService()
    this.batimentService = new BatimentService()
    this.niveauService = new NiveauService()
    this.couloirService = new CouloirService()
    this.chambreService = new ChambreService()
    this.litService = new LitService()
    this.affectationService = new AffectationService()
    this.userService = new UtilisateurService()
    this.sessionService = new SessionService()
  }

  componentDidMount() {
    const data = localStorage.getItem('user')
    if(data){
      const user = JSON.parse(data)
      const idDirection = user.idDirection
      this.sessionService.getSessionDirection(idDirection).then(data => {
      const annees = data
      const maxIdAnnee = annees.reduce((max, item) =>
        item.idAnnee > max.idAnnee ? item : max
      );
      console.log(maxIdAnnee)
      this.setState({session: maxIdAnnee})
    })
    .catch(error => {
      console.log(error.response.data)
    })
      this.villeService.getVilleDirection(user.idDirection).then(resp => {
        console.log(resp)
        let villes = Array.isArray(resp) ? resp : []
        if(villes.length>0){
           villes = villes.filter(ville => ville.nomVille !== "SAABA");
        }
        this.setState({ villes : villes });
    })
    .catch(error => {
        console.log(error)
    })
      this.setState({user : user})
    }
    
    
  }

  onInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async searchStudent() {
    const matricule = (this.state.ine || '').trim();
    if (!matricule) {
      this.setState({ searchMessage: 'Saisir INE', student: null });
      return;
    }
    this.setState({ loading: true, searchMessage: '', student: null });
    try {
      const resp = await this.userService.findByStudentCite(matricule,this.state.session.idSessionCenou,this.state.selectedCite.idCite);
      let student = null;
      if (!resp) student = null;
      else if (resp.ine) student = resp;
      else if (Array.isArray(resp) && resp.length > 0) student = resp[0];

      if (student) {
        this.setState({ student, searchMessage: '' });
      } else {
        this.setState({ student: null, searchMessage: "L'étudiant n'existe pas" });
      }
    } catch (err) {
      console.error('searchStudent', err);
      this.setState({ student: null, searchMessage: err.response.data.message || "Erreur lors de la recherche" });
    } finally {
      this.setState({ loading: false });
    }
  }

  async onVilleChange(e) {
    const ville = e.value;
    this.setState({
      selectedVille: ville,
      cites: [], selectedCite: null,
      batiments: [], selectedBatiment: null,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    this.citeService.getCitesVille(ville.idVille).then(data => {
      console.log(data)
      const cites = Array.isArray(data) ? data : []
      this.setState({ cites :  cites});
    })
    .catch(error => {
      console.log(error)
    })
  }
  async onCiteChange(e) {
    const cite = e.value
    this.setState({
      selectedCite: cite,
      batiments: [], selectedBatiment: null,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });

    try {
      const data = await this.batimentService.get(cite.idCite);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ batiments: opts });
    } catch (err) {
      console.error('getBatiments', err);
      this.setState({ batiments: [] });
    }
    
  }

  async onBatimentChange(e) {
    const batiment = e.value;
    this.setState({
      selectedBatiment: batiment,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.niveauService.get(batiment.idBatiment);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ niveaux: opts });
    } catch (err) {
      console.error('getNiveaux', err);
      this.setState({ niveaux: [] });
    }
  }

  async onNiveauChange(e) {
    const niveau = e.value;
    this.setState({
      selectedNiveau: niveau,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.couloirService.get(niveau.idNiveau);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ couloirs: opts });
    } catch (err) {
      console.error('getCouloirs', err);
      this.setState({ couloirs: [] });
    }
  }

  async onCouloirChange(e) {
    const couloir = e.value;
    console.log(couloir)
    this.setState({
      selectedCouloir: couloir,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.chambreService.get(couloir.idCouloir);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ chambres: opts });
    } catch (err) {
      console.error('getChambres', err);
      this.setState({ chambres: [] });
    }
  }

  async onChambreChange(e) {
    const chambre = e.value;
    this.setState({ selectedChambre: chambre, lits: [], selectedLit: null, occupants: [] });
    try {
      const lits = await this.litService.get(chambre.idChambre);
      const litOpts = Array.isArray(lits) ? lits: [];
      const occupants = await this.affectationService.getOccupantsByChambre(chambre.idChambre);
      const litsLibres = occupants.litsLibres
      const litsOccupes = occupants.litsOccupes
      
      this.setState({ lits: litOpts, occupants:  litsOccupes, litsLibres : litsLibres});
    } catch (err) {
      console.error('onChambreChange', err);
      this.setState({ lits: [], occupants: [] });
    }
  }

  async assignToBed() {
    const { student, selectedCite, selectedBatiment, selectedNiveau, selectedCouloir, selectedChambre, selectedLit } = this.state;
    if (!student) { alert('Recherche d’abord un étudiant valide.'); return; }
    if (!selectedCite || !selectedBatiment || !selectedNiveau || !selectedCouloir || !selectedChambre || !selectedLit) {
      alert('Sélectionnez tous les niveaux (cité → bâtiment → niveau → couloir → chambre → lit).');
      return;
    }

    const payload = {
      idEtudiant: student.idEtudiant,
      idLit: selectedLit.idLit,
      idSessionCenou: this.state.session.idSessionCenou
    };
    console.log(payload)

    this.setState({ loading: true });
    try {
      const res = await this.affectationService.assignToBed(payload);
      //console.log(res)
      if (res && res.message) {
        alert(res.message || "Lit déjà affecté !");
      } else {
        alert('Affectation reussi');
      }
      const occupants = await this.affectationService.getOccupantsByChambre(selectedChambre.idChambre);
      const litsLibres = occupants.litsLibres
      const litsOccupes = occupants.litsOccupes
      //const litsChambre = [...litsLibres, ...litsOccupes];
      //console.log(occupants)
      this.setState({ occupants: litsOccupes, litsLibres : litsLibres,  student: null, ine: '' });
    } catch (err) {
      console.error('assignToBed', err);
      console.error(err.response);
      if (err.status === 409 || (err.body && err.body.message && /déjà/i.test(err.body.message))) {
        alert(err.body && err.body.message ? err.body.message : 'Le lit est déjà affecté à un étudiant.');
      } else {
        alert('Erreur lors de l\'affectation. ' + (err.response.data && err.response.data.message ? err.response.data.message : ''));
      }
    } finally {
      this.setState({ loading: false });
    }
  }

  async openAssignedModal() {
    const citeId = this.state.selectedCite;
    this.setState({ loading: true });
    try {
      const data = await this.affectationService.getAssignedListByCite(citeId.idCite);
      this.setState({ assignedList: Array.isArray(data) ? data : [], assignedModalVisible: true });
    } catch (err) {
      console.error('openAssignedModal', err);
      alert('Erreur récupération liste des affectés');
    } finally {
      this.setState({ loading: false });
    }
  }

  exportAssignedExcel() {
    const data = this.state.assignedList || [];
    if (data.length === 0) { alert('Aucune donnée à exporter'); return; }
    const sheetData = data.map(row => ({
      idDossier: row.idDossier || row.studentId || '',
      INE: row.INE || row.ine || row.matricule || '',
      nom: row.nom || '',
      prenom: row.prenom || '',
      sexe: row.sexe || '',
      telephone: row.telephone || '',
      cite: row.citeName || row.cite || '',
      batiment: row.batimentName || row.batiment || '',
      niveau: row.niveauName || row.niveau || '',
      couloir: row.couloirName || row.couloir || '',
      chambre: row.chambreName || row.chambre || '',
      lit: row.litNumber || row.lit || ''
    }));
    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Affectés');
    const wbout = XLSX.write(wb, { bookType:'xlsx', type:'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'affectes.xlsx');
  }

  exportAssignedPdf() {
    const data = this.state.assignedList || [];
    if (data.length === 0) { alert('Aucune donnée à exporter'); return; }
    const doc = new jsPDF();
    const columns = [
      { header: 'idDossier', dataKey: 'idDossier' },
      { header: 'INE', dataKey: 'INE' },
      { header: 'Nom', dataKey: 'nom' },
      { header: 'Prénom', dataKey: 'prenom' },
      { header: 'Sexe', dataKey: 'sexe' },
      { header: 'Téléphone', dataKey: 'telephone' },
      { header: 'Cité', dataKey: 'cite' },
      { header: 'Bâtiment', dataKey: 'batiment' },
      { header: 'Niveau', dataKey: 'niveau' },
      { header: 'Couloir', dataKey: 'couloir' },
      { header: 'Chambre', dataKey: 'chambre' },
      { header: 'Lit', dataKey: 'lit' }
    ];
    const rows = data.map(row => ({
      idDossier: row.idDossier || row.studentId || '',
      INE: row.INE || row.ine || row.matricule || '',
      nom: row.nom || '',
      prenom: row.prenom || '',
      sexe: row.sexe || '',
      telephone: row.telephone || '',
      cite: row.citeName || row.cite || '',
      batiment: row.batimentName || row.batiment || '',
      niveau: row.niveauName || row.niveau || '',
      couloir: row.couloirName || row.couloir || '',
      chambre: row.chambreName || row.chambre || '',
      lit: row.litNumber || row.lit || ''
    }));
    doc.autoTable({ columns, body: rows, startY: 20 });
    doc.save('affectes.pdf');
  }

  render() {
    /*const {
      ine, student, searchMessage,
      villes,selectedVille,
      cites, selectedCite,
      batiments, selectedBatiment,
      niveaux, selectedNiveau,
      couloirs, selectedCouloir,
      chambres, selectedChambre,
      lits, selectedLit,
      occupants, assignedModalVisible, assignedList, loading
    } = this.state;*/

    return (
      <div className="bed-assignment-module">
        <h3>Affectation lits - Cités universitaires</h3>

        <div className="p-grid" style={{ marginBottom: 12 }}>
          <div className="p-col-3">
            <label>Ville</label><br />
            <Dropdown value={this.state.selectedVille} optionLabel="nomVille" options={this.state.villes} onChange={(e) => {this.onVilleChange(e)}} placeholder="Choisir une ville" />
          </div>
          <div className="p-col-3">
            <label>Cité</label><br />
            <Dropdown value={this.state.selectedCite} optionLabel="nomCite" options={this.state.cites} onChange={(e)=>{this.onCiteChange(e)}} placeholder="Choisir une cité" />
          </div>
          <div className="p-col-6">
            <label>INE</label><br />
            <InputText name="ine" value={this.state.ine} onChange={this.onInputChange} placeholder="Saisir INE" />
            <Button label="Rechercher" icon="pi pi-search" onClick={this.searchStudent} style={{ marginLeft: 8 }} />
          </div>
          {/*<div className="p-col-6">
            <label>Liste des affectés (par cité)</label><br />
            <Dropdown value={this.state.selectedCite} options={this.state.cites} onChange={this.onCiteChange} placeholder="Choisir une cité" />
            <Button label="Voir affectés" icon="pi pi-users" onClick={this.openAssignedModal} style={{ marginLeft: 8 }} />
          </div>*/}
        </div>

        {this.state.searchMessage && <div className="p-messages p-messages-warn">{this.state.searchMessage}</div>}
        {this.state.student &&
          <Panel header="Étudiant trouvé" style={{ marginBottom: 12 }}>
            <div><strong>INE:</strong> {this.state.student.ine}</div>
            <div><strong>Nom:</strong> {this.state.student.nomEtudiant}</div>
            <div><strong>Prénom:</strong> {this.state.student.prenomEtudiant}</div>
            <div><strong>Sexe:</strong> {this.state.student.sexeEtudiant}</div>
            <div><strong>Téléphone:</strong> {this.state.student.telEtudiant}</div>
            <div><strong>Téléphone:</strong> {this.state.student.emailEtudiant}</div>
            <div><strong>Téléphone:</strong> {this.state.student.universite}</div>
            <div><strong>Téléphone:</strong> {this.state.student.filiere}</div>
          </Panel>
        }

        <div className="p-grid" style={{ marginBottom: 12 }}>
          <div className="p-col-3">
            <label>Bâtiment</label><br />
            <Dropdown value={this.state.selectedBatiment} optionLabel="libelleBatiment" options={this.state.batiments} onChange={this.onBatimentChange} placeholder="Choisir un bâtiment" />
          </div>
          <div className="p-col-3">
            <label>Niveau</label><br />
            <Dropdown value={this.state.selectedNiveau} optionLabel="libelleNiveau" options={this.state.niveaux} onChange={this.onNiveauChange} placeholder="Choisir un niveau" />
          </div>
        </div>

        <div className="p-grid" style={{ marginBottom: 12 }}>
          <div className="p-col-3">
            <label>Couloir</label><br />
            <Dropdown value={this.state.selectedCouloir} optionLabel="libelleCouloir" options={this.state.couloirs} onChange={this.onCouloirChange} placeholder="Choisir un couloir" />
          </div>
          <div className="p-col-3">
            <label>Chambre</label><br />
            <Dropdown value={this.state.selectedChambre} optionLabel="libelleChambre" options={this.state.chambres} onChange={this.onChambreChange} placeholder="Choisir une chambre" />
          </div>
          <div className="p-col-3">
            <label>Lit</label><br />
            <Dropdown value={this.state.selectedLit} optionLabel="libelleLit" options={this.state.lits} onChange={(e) => this.setState({ selectedLit: e.value })} placeholder="Choisir un lit" />
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <Button label="Enregistrer affectation au lit" icon="pi pi-save" onClick={this.assignToBed} />
        </div>
        <div className='p-grid'>
          <div className='p-col-4'>
            <Panel header="Lits libre(chambre sélectionnée)">
              <DataTable value={this.state.litsLibres} paginator rows={10}>
                <Column field="codeLit" header="Code lit" />
                <Column field="libelleLit" header="N° Lit" />
              </DataTable>
            </Panel>
          </div>
          <div className='p-col-8'>
            <Panel header="Lits et occupants (chambre sélectionnée)">
              <DataTable value={this.state.occupants} paginator rows={10}>
                <Column field="lit.codeLit" header="Code lit" />
                <Column field="lit.libelleLit" header="N° Lit" />
                <Column field="etudiant.ine" header="INE"/>
                <Column field="etudiant.nom" header="Nom" />
                <Column field="etudiant.prenom" header="Prénom" />
                <Column field="etudiant.sexe" header="Sexe" />
                <Column field="etudiant.telephone" header="Téléphone" />
                <Column field="etudiant.filiere" header="Filière" />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog header="Étudiants déjà affectés" visible={this.state.assignedModalVisible}
                style={{ width: '80%' }} modal onHide={() => this.setState({ assignedModalVisible: false })}>
          <div style={{ marginBottom: 8 }}>
            <Button label="Exporter Excel" icon="pi pi-file-excel" onClick={this.exportAssignedExcel} style={{ marginRight: 8 }} />
            <Button label="Exporter PDF" icon="pi pi-file-pdf" onClick={this.exportAssignedPdf} />
          </div>
          <DataTable value={this.state.assignedList} paginator rows={10}>
            {/*<Column field="idDossier" header="idDossier" />*/}
            <Column field="ine" header="INE" />
            <Column field="nomEtudiant" header="Nom" />
            <Column field="prenomEtudiant" header="Prénom" />
            <Column field="sexeEtudiant" header="Sexe" />
            <Column field="telEtudiant" header="Téléphone" />
            <Column field="nomCite" header="Cité" />
            <Column field="libelleBatiment" header="Bâtiment" />
            <Column field="libelleNiveau" header="Niveau" />
            <Column field="libelleCouloir" header="Couloir" />
            <Column field="libelleChambre" header="Chambre" />
            <Column field="libelleLit" header="Lit" />
          </DataTable>
        </Dialog>

        {this.state.loading && <div style={{ marginTop: 12 }}>Chargement...</div>}
      </div>
    );
  }
}
